import { State } from 'store';
import getSelectedWorkflowDefinitionDetails from './getSelectedWorkflowDefinitionDetails';

export default function getInputsSchema(state: State) {
  const details = getSelectedWorkflowDefinitionDetails(state);
  return details && (details.inputs_schema.inputs || {});
}
